// Collection of fixes that are used on links in TipTap
import { BrowserAgent } from "./BrowserAgent";

/**
 * On tiptap, when a cursor goes through a mention, it disappears and won't
 * show itself at the end of it.
 *
 * This fix detects and properly positions the cursor
 */

type WindowAndDrag = Window & { drag?: "STARTED" | "MOVING" | "ENDED" };

function onDragStart() {
  if (
    (window as WindowAndDrag).drag === undefined ||
    (window as WindowAndDrag).drag === "ENDED"
  ) {
    (window as WindowAndDrag).drag = "STARTED";
  }
}

function onDrag() {
  if ((window as WindowAndDrag).drag === "STARTED") {
    (window as WindowAndDrag).drag = "MOVING";
  }
}

function onDragEnd() {
  if (
    (window as WindowAndDrag).drag === "MOVING" ||
    (window as WindowAndDrag).drag === "STARTED"
  ) {
    (window as WindowAndDrag).drag = "ENDED";
  }
}

function onSelectionChange(event: Event) {
  // Here, I get the selection and test if it's on the end of a mention,
  // currently, we only support STRONG, UNDERLINE and ITALIC
  let currentSelection = (window as WindowAndDrag).getSelection();

  // When it's webkit, I need the links to be contentEditable at ALL times
  if (BrowserAgent.isWebKit()) {
    // Toggle all links contentEditable false (default)
    document
      .querySelectorAll(".ProseMirror a")
      .forEach(
        (anchor: HTMLAnchorElement) => (anchor.contentEditable = "true")
      );

    // Fix an issue that if there's a <br> on the end of the link, it fails
    document
      .querySelectorAll(".ProseMirror br")
      .forEach((brElement: HTMLBRElement) => {
        if (
          !brElement.nextSibling &&
          brElement.previousSibling &&
          brElement.previousSibling?.nodeName !== "IMG" &&
          brElement.previousSibling?.nodeName !== "BR"
        ) {
          // Add a zero-width space to the <br>
          brElement.outerHTML = `&#8203${brElement.outerHTML}`;
        }
      });

    if (!currentSelection.isCollapsed) return;
  }

  if ((window as WindowAndDrag).drag === "MOVING") return;

  // Check if it's on a mention, if it's not, return
  if (
    currentSelection.anchorNode?.nodeName !== "STRONG" &&
    currentSelection.anchorNode?.nodeName !== "U" &&
    currentSelection.anchorNode?.nodeName !== "EM"
  )
    return;

  // If it's at the end of the mention, then position the cursor on the parent
  if (currentSelection.anchorOffset === 1) {
    let range = document.createRange();

    // Go to the parent element, removing the caret from the mention and putting it into the <p />
    let mentionNodeIndex = Array.from(
      currentSelection.anchorNode.parentElement.childNodes
    ).indexOf(currentSelection.anchorNode as Element);

    range.setStart(
      currentSelection.anchorNode.parentElement,
      mentionNodeIndex + 1
    );
    range.collapse(true);
    currentSelection.removeAllRanges();

    currentSelection.addRange(range);
  }
}

export function fixCursorOnFrontOfTheLink() {
  // Setup
  document.addEventListener("selectionchange", onSelectionChange);
  document.addEventListener("mousedown", onDragStart);
  document.addEventListener("mousemove", onDrag);
  document.addEventListener("mouseup", onDragEnd);

  // Cleanup
  return {
    clearListener: () => {
      document.removeEventListener("selectionchange", onSelectionChange);
      document.removeEventListener("mousedown", onDragStart);
      document.removeEventListener("mousemove", onDrag);
      document.removeEventListener("mouseup", onDragEnd);
    },
  };
}
